export const notificationsRouteNames = {
  default: 'notifications-v2',
  list: 'notificationslist-v2',
}
